export default {
    "name": "ProductVariant",
    "kind": "HoudiniQuery",
    "hash": "6d6045090b0fef4637dc2f7e0aaf59cd2ddca00979e5a99b9dd876fc1fd44319",

    "raw": `query ProductVariant($id: ID!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
  node(id: $id) {
    ...ProductVariantData
    id
    __typename
  }
}

fragment ProductVariantData on ProductVariant {
  id
  selectedOptions {
    name
    value
  }
  sku: metafield(key: "just_sku", namespace: "sprenger") {
    key
    value
    id
  }
  price {
    amount
    currencyCode
  }
  compareAtPrice {
    amount
    currencyCode
  }
  availableForSale
  quantityAvailable
  currentlyNotInStock
  title
  product {
    title
    handle
    collections(first: 10) {
      edges {
        node {
          title
          handle
          description
          path: metafield(key: "path", namespace: "sprenger") {
            key
            value
            id
          }
          id
        }
      }
    }
    id
  }
  isArchived: metafield(key: "is_archived", namespace: "sprenger") {
    key
    value
    id
  }
  bundle_desc: metafield(key: "bundle_desc", namespace: "sprenger") {
    key
    value
    id
  }
  care_d2c: metafield(key: "care_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  content_d2c: metafield(key: "content_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  measure_d2c: metafield(key: "measure_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  material_d2c: metafield(key: "material_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  faq_d2c: metafield(key: "faq_d2c", namespace: "sprenger") {
    key
    value
    id
  }
  colorcode: metafield(key: "colorcode", namespace: "sprenger") {
    key
    value
    id
  }
  technical_data: metafield(key: "technical_data", namespace: "sprenger") {
    key
    value
    id
  }
  image_urls: metafield(key: "image_urls", namespace: "sprenger") {
    key
    value
    id
  }
  bulletPoints: metafield(key: "bullets", namespace: "sprenger") {
    key
    value
    id
  }
  dreid: metafield(key: "dreid", namespace: "sprenger") {
    key
    value
    id
  }
  video: metafield(key: "video", namespace: "sprenger") {
    key
    value
    id
  }
  hazard_data: metafield(key: "hazard_data", namespace: "sprenger") {
    key
    value
    id
  }
  crossSellReferences: metafield(
    key: "crosssell_references"
    namespace: "sprenger"
  ) {
    key
    value
    id
  }
  highlights: metafield(key: "highlights", namespace: "sprenger") {
    key
    value
    id
  }
  sds_qty: metafield(key: "sds_qty", namespace: "sprenger") {
    key
    value
    id
  }
  unitPrice {
    amount
    currencyCode
  }
  unitPriceMeasurement {
    referenceValue
    referenceUnit
  }
  __typename
}
`,

    "rootType": "QueryRoot",

    "selection": {
        "fields": {
            "node": {
                "type": "Node",
                "keyRaw": "node(id: $id)",
                "nullable": true,

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "ProductVariant": {
                                "id": {
                                    "type": "ID",
                                    "keyRaw": "id",
                                    "visible": true
                                },

                                "selectedOptions": {
                                    "type": "SelectedOption",
                                    "keyRaw": "selectedOptions",

                                    "selection": {
                                        "fields": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "sku": {
                                    "type": "Metafield",
                                    "keyRaw": "sku(key: \"just_sku\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "price": {
                                    "type": "MoneyV2",
                                    "keyRaw": "price",

                                    "selection": {
                                        "fields": {
                                            "amount": {
                                                "type": "Decimal",
                                                "keyRaw": "amount",
                                                "visible": true
                                            },

                                            "currencyCode": {
                                                "type": "CurrencyCode",
                                                "keyRaw": "currencyCode",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "compareAtPrice": {
                                    "type": "MoneyV2",
                                    "keyRaw": "compareAtPrice",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "amount": {
                                                "type": "Decimal",
                                                "keyRaw": "amount",
                                                "visible": true
                                            },

                                            "currencyCode": {
                                                "type": "CurrencyCode",
                                                "keyRaw": "currencyCode",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "availableForSale": {
                                    "type": "Boolean",
                                    "keyRaw": "availableForSale",
                                    "visible": true
                                },

                                "quantityAvailable": {
                                    "type": "Int",
                                    "keyRaw": "quantityAvailable",
                                    "nullable": true,
                                    "visible": true
                                },

                                "currentlyNotInStock": {
                                    "type": "Boolean",
                                    "keyRaw": "currentlyNotInStock",
                                    "visible": true
                                },

                                "title": {
                                    "type": "String",
                                    "keyRaw": "title",
                                    "visible": true
                                },

                                "product": {
                                    "type": "Product",
                                    "keyRaw": "product",

                                    "selection": {
                                        "fields": {
                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "visible": true
                                            },

                                            "handle": {
                                                "type": "String",
                                                "keyRaw": "handle",
                                                "visible": true
                                            },

                                            "collections": {
                                                "type": "CollectionConnection",
                                                "keyRaw": "collections(first: 10)",

                                                "selection": {
                                                    "fields": {
                                                        "edges": {
                                                            "type": "CollectionEdge",
                                                            "keyRaw": "edges",

                                                            "selection": {
                                                                "fields": {
                                                                    "node": {
                                                                        "type": "Collection",
                                                                        "keyRaw": "node",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "title": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "title",
                                                                                    "visible": true
                                                                                },

                                                                                "handle": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "handle",
                                                                                    "visible": true
                                                                                },

                                                                                "description": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "description",
                                                                                    "visible": true
                                                                                },

                                                                                "path": {
                                                                                    "type": "Metafield",
                                                                                    "keyRaw": "path(key: \"path\", namespace: \"sprenger\")",
                                                                                    "nullable": true,

                                                                                    "selection": {
                                                                                        "fields": {
                                                                                            "key": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "key",
                                                                                                "visible": true
                                                                                            },

                                                                                            "value": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "value",
                                                                                                "visible": true
                                                                                            },

                                                                                            "id": {
                                                                                                "type": "ID",
                                                                                                "keyRaw": "id",
                                                                                                "visible": true
                                                                                            }
                                                                                        }
                                                                                    },

                                                                                    "visible": true
                                                                                },

                                                                                "id": {
                                                                                    "type": "ID",
                                                                                    "keyRaw": "id",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "isArchived": {
                                    "type": "Metafield",
                                    "keyRaw": "isArchived(key: \"is_archived\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "bundle_desc": {
                                    "type": "Metafield",
                                    "keyRaw": "bundle_desc(key: \"bundle_desc\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "care_d2c": {
                                    "type": "Metafield",
                                    "keyRaw": "care_d2c(key: \"care_d2c\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "content_d2c": {
                                    "type": "Metafield",
                                    "keyRaw": "content_d2c(key: \"content_d2c\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "measure_d2c": {
                                    "type": "Metafield",
                                    "keyRaw": "measure_d2c(key: \"measure_d2c\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "material_d2c": {
                                    "type": "Metafield",
                                    "keyRaw": "material_d2c(key: \"material_d2c\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "faq_d2c": {
                                    "type": "Metafield",
                                    "keyRaw": "faq_d2c(key: \"faq_d2c\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "colorcode": {
                                    "type": "Metafield",
                                    "keyRaw": "colorcode(key: \"colorcode\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "technical_data": {
                                    "type": "Metafield",
                                    "keyRaw": "technical_data(key: \"technical_data\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "image_urls": {
                                    "type": "Metafield",
                                    "keyRaw": "image_urls(key: \"image_urls\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "bulletPoints": {
                                    "type": "Metafield",
                                    "keyRaw": "bulletPoints(key: \"bullets\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "dreid": {
                                    "type": "Metafield",
                                    "keyRaw": "dreid(key: \"dreid\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "video": {
                                    "type": "Metafield",
                                    "keyRaw": "video(key: \"video\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "hazard_data": {
                                    "type": "Metafield",
                                    "keyRaw": "hazard_data(key: \"hazard_data\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "crossSellReferences": {
                                    "type": "Metafield",
                                    "keyRaw": "crossSellReferences(key: \"crosssell_references\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "highlights": {
                                    "type": "Metafield",
                                    "keyRaw": "highlights(key: \"highlights\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "sds_qty": {
                                    "type": "Metafield",
                                    "keyRaw": "sds_qty(key: \"sds_qty\", namespace: \"sprenger\")",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "key": {
                                                "type": "String",
                                                "keyRaw": "key",
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "id": {
                                                "type": "ID",
                                                "keyRaw": "id",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "unitPrice": {
                                    "type": "MoneyV2",
                                    "keyRaw": "unitPrice",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "amount": {
                                                "type": "Decimal",
                                                "keyRaw": "amount",
                                                "visible": true
                                            },

                                            "currencyCode": {
                                                "type": "CurrencyCode",
                                                "keyRaw": "currencyCode",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "unitPriceMeasurement": {
                                    "type": "UnitPriceMeasurement",
                                    "keyRaw": "unitPriceMeasurement",
                                    "nullable": true,

                                    "selection": {
                                        "fields": {
                                            "referenceValue": {
                                                "type": "Int",
                                                "keyRaw": "referenceValue",
                                                "visible": true
                                            },

                                            "referenceUnit": {
                                                "type": "UnitPriceMeasurementMeasuredUnit",
                                                "keyRaw": "referenceUnit",
                                                "nullable": true,
                                                "visible": true
                                            }
                                        }
                                    },

                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    },

                    "fragments": {
                        "ProductVariantData": {
                            "arguments": {}
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "id": "ID",
            "country": "CountryCode",
            "language": "LanguageCode"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=e1e56688b8fb53f046973a261fedd66e816ad8ec61d649da3b8a82af08e76755";